import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../../util/ext";

import { Box } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },

  toolbar: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "white",
    background: "white",
    padding: theme.spacing(4),
  },
}));

const FilterBar = ({ backButton, otherFilters, filterMenu }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.toolbar}>
        {notBlank(backButton) && (
          <Box mr={2} alignSelf="flex-start">
            {backButton}
          </Box>
        )}
        {notBlank(filterMenu) && (
          <Box ml={2} flexBasis="33%">
            {filterMenu}
          </Box>
        )}
        {notBlank(otherFilters) && (
          <Box ml={2} flexBasis={notBlank(filterMenu) ? "50%" : "100%"}>
            {otherFilters}
          </Box>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
